import { defaultBreakpoint } from '../../utils/defaults';
import { isPixelValue } from '../../utils/line-height-to-px';
import { toMobileFontSize } from '../../utils/font-utils/to-mobile-font-size';
export const buildCssMobile = (css) => `@media all and (max-width: ${defaultBreakpoint}) {
    .so-link-image td {width: 100%!important;}
  }@media all and (max-width: ${defaultBreakpoint}) {
    ${[getMobileFontSizeCss(css), getMobileLineHeightCss(css)].join('')}

    .html-emails-button-mobile > table {
      width: 100%!important;
    }

    .html-emails-button-empty-div-mobile {
      display: none!important;
    }

    .PB24 .html-email-body-column > table > tbody > tr > td {
      padding-bottom: 24px!important;
    }

    .PT24 .html-email-body-column > table > tbody > tr > td {
      padding-top: 24px!important;
    }

    .PB24.html-email-body-column > table > tbody > tr > td {
      padding-bottom: 24px!important;
    }

    .PT24.html-email-body-column > table > tbody > tr > td {
      padding-top: 24px!important;
    }

    .PT16 .html-email-body-column > table > tbody > tr > td {
      padding-top: 16px!important;
    }

    .PR16 .html-email-body-column > table > tbody > tr > td {
      padding-right: 16px!important;
    }

    .PB16 .html-email-body-column > table > tbody > tr > td {
      padding-bottom: 16px!important;
    }

    .PL16 .html-email-body-column > table > tbody > tr > td {
      padding-left: 16px!important;
    }

    .PL0 .html-email-body-column > table > tbody > tr > td {
      padding-left: 0px!important;
    }

    .PR0 .html-email-body-column > table > tbody > tr > td {
      padding-right: 0px!important;
    }

    .MR16 > table > tbody > tr > td {
      padding-right: 16px!important;
    }

    .ML16 > table > tbody > tr > td {
      padding-left: 16px!important;
    }
  }`;
function getMobileFontSizeCss(css) {
    const classToMobileFontSize = cssToArrayOfClassNameFontSize(css)
        .filter((clazz) => !!clazz.fontSize)
        .reduce(convertToMobileFontSize, {});
    return Object.keys(classToMobileFontSize)
        .map((className) => `.${className}{font-size:${classToMobileFontSize[className]}px!important;}`)
        .join('');
}
function cssToArrayOfClassNameFontSize(css) {
    return Object.keys(css).map((className) => ({
        className,
        fontSize: css[className].fontSize,
    }));
}
function convertToMobileFontSize(acc, { className, fontSize }) {
    return Object.assign(Object.assign({}, acc), { [className]: applyCustomFontConversions(className, toMobileFontSize(fontSize)) });
}
function applyCustomFontConversions(className, fontSize) {
    if (className === 'so-global-footer-text' && fontSize < 14) {
        return 14;
    }
    return fontSize;
}
const fontsSizeToLineHeightRatio = 1.4;
function cssToArrayOfClassNameLineHeight(css) {
    return Object.keys(css).map((className) => ({
        className,
        fontSize: css[className].fontSize,
        lineHeight: css[className].lineHeight,
        lineHeightRatio: css[className].originalLineHeight || fontsSizeToLineHeightRatio,
    }));
}
function convertToMobileLineHeight(acc, { className, fontSize, lineHeightRatio, lineHeight }) {
    const ratio = isPixelValue(lineHeight) ? lineHeightRatio : lineHeight;
    return Object.assign(Object.assign({}, acc), { [className]: toMobileFontSize(fontSize) * ratio });
}
function getMobileLineHeightCss(css) {
    const classToMobileLineHeight = cssToArrayOfClassNameLineHeight(css)
        .filter((clazz) => !!clazz.lineHeight)
        .reduce(convertToMobileLineHeight, {});
    return Object.keys(classToMobileLineHeight)
        .map((className) => `.${className}{line-height:${classToMobileLineHeight[className]}px!important;}`)
        .join('');
}
//# sourceMappingURL=build-css-mobile.js.map